import {
  FormHelperText,
  Box,
  RadioGroup as MuiRadioGroup,
  FormLabel,
  Radio as MuiRadio,
  FormControlLabel
} from '@mui/material';
import React, { forwardRef } from 'react';

import { RadioGroupProps } from './types';

const Radio = forwardRef<HTMLInputElement, RadioGroupProps>(
  ({ error, helperText, label, options, name, onChange, ...props }, ref) => {
    const handleChange = (event: any, value: any) => {
      if (onChange) {
        onChange(event);
      }
    };
    return (
      <>
        <Box sx={{ mb: 2 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <FormLabel sx={{ mb: 1 }}>{label}</FormLabel>
            <MuiRadioGroup name={name} onChange={handleChange} {...props}>
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: 3 }}>
                {options?.map(item => {
                  return (
                    <Box
                      key={item.key}
                      sx={{
                        width: '100%',
                        border: 1,
                        borderColor: '#E5E5E5',
                        borderRadius: '8px',
                        height: 48,
                        background: 'rgba(190, 190, 190, 0.10)',
                        padding: '5px 0',
                        '&:hover': {
                          borderColor: '#833CE2'
                        }
                      }}
                    >
                      <FormControlLabel
                        sx={{ display: 'flex', justifyContent: 'space-between', pr: 2 }}
                        labelPlacement="start"
                        value={item.key}
                        control={<MuiRadio disabled={item.disabled ? item.disabled : false} />}
                        label={item.value}
                      />
                    </Box>
                  );
                })}
              </Box>
            </MuiRadioGroup>
          </Box>
          <FormHelperText error={error}> {helperText} </FormHelperText>
        </Box>
      </>
    );
  }
);

Radio.displayName = 'Radio';

export default Radio;
